import { mapState } from 'vuex'
export default {
  data() {
    return {
      selectedIndex: 0
    }
  },
  computed: {
    ...mapState({
      missionsSettings: state => state.activities['mission-reward'].missionsSettings,
      missionBadge: state => state.activities['mission-reward'].missionBadge
    }),
    activitiesTypeList() {
      const list = [
        {
          title: this.tl('weeklyMission'),
          value: 1,
          display: this.missionsSettings?.mission_type_settings?.[1]?.status
        },
        {
          title: this.tl('monthlyMission'),
          value: 2,
          display: this.missionsSettings?.mission_type_settings?.[2]?.status
        },
        {
          title: this.tl('eventTriggerMission'),
          value: 3,
          display: this.missionsSettings?.mission_type_settings?.[3]?.status
        },
        {
          title: this.tl('actionBasedMission'),
          value: 4,
          display: this.missionsSettings?.mission_type_settings?.[4]?.status
        }
      ]
      return list.filter(el => el.display)
    }
  },
  watch: {
    selectedIndex(value) {
      this.$router.push({ query: { mission_type: value } })
    },
    activitiesTypeList(value) {
      // Check if the activities type list is fetched by API response already?
      // If yes, all the display values must be boolean
      if (value) {
        // By default, all the .display values are set to undefined
        // So, we need to make sure that the API response is fetched before setting the default selectedIndex (v-tab model)
        const allDisplayAreBoolean = value?.every(el => typeof el.display === 'boolean')
        if (allDisplayAreBoolean && this.$route.query.mission_type) {
          const missionType = parseInt(this.$route.query.mission_type)
          if (this.activitiesTypeList?.length > 0) {
            if (missionType >= this.activitiesTypeList?.length + 1) {
              this.selectedIndex = 0
            }
          }
        }
      }
    }
  },
  mounted() {
    if (this.$route.query.mission_type) {
      this.selectedIndex = parseInt(this.$route.query.mission_type)
    }
  },
  methods: {
    onClickMissionType(index) {
      this.selectedIndex = index
      // Fetch mission settings for each click by TICKET:
      // WLD-9?commentId=26133
      // Add frequent API calls triggered by ser clicks on mission buttons
      this.$store.dispatch('activities/mission-reward/getMissionSettings', {
        currency: this.$store.state.settings.defaultCurrency
      })
    }
  }
}
